import { Component, OnInit, OnDestroy, Input, ViewChild, Inject, ElementRef, HostListener, LOCALE_ID } from "@angular/core";
import { Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from "@angular/router";
import { appConstants } from '../../constants/app.constants';
import { LoginComponent } from 'src/app/shared/components/login/login.component';
import { AddCardModalComponent } from 'src/app/shared/components/addCard-modal/addCard-modal.component';
import { AuthService } from '../../services/auth/auth.service';
import { ApiService } from 'src/app/config/api.service';
import { OfferService } from 'src/app/offers/services/offer/offer.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { CountryModalComponent } from 'src/app/shared/components/country-modal/country-modal.component';
import { SearchComponent } from 'src/app/shared/components/search-modal/search-modal.component';
import { DOCUMENT } from '@angular/common';

import { Store } from '@ngrx/store';
import {select} from '@ngrx/store';
import * as cardsActions from 'src/app/store/actions/cards.action';
import { Title } from "@angular/platform-browser";
import { Category } from "../../interfaces/offers.interface";

export interface ILanguage {
  attributes: {
    code: string,
    id: string,
    iso639_1: string,
    name: string
  },
  id: string,
  type: string
}

export type Country = {
  id: string;
  type: string;
  attributes: {
    id: string;
    name: string;
    flag_url: [string, string];
    code: string;
    iso_code: string;
    iso2_code: string;
    calling_codes: number[];
    mobile_length: string;
    currency_symbol: string | null;
    currency_code: string | null;
    region: string;
    languages: {
      id: string;
      iso639_1: string;
      name: string;
    }[];
    mobile_allowed_lengths: number[];
    min_mobile_digit: number;
    max_mobile_digit: number;
  };
};

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy{
  modalRef: BsModalRef;
  sideMenu = false;
  @Input('sidenav') sidenav;
  appConstants = appConstants;
  @ViewChild('accDrop') accDrop;
  @ViewChild('accDropCon') accDropCon;
  openMenu: boolean;
  private languages: ILanguage[] = [];
  public filteredLanguages: ILanguage[] = [];
  public hideInDropdownLanguages = [];
  public availableTranslatedLanguages = ["en", "es", "vi", "zh", "zh-TW", "zh-HK", "ko", "id", "ja", "ar", "th", "fr", "my", "az", "kk", "ka", "uz", "ru", "uk", "ur", "fr-ca"];
  public selectedCountryDetails: Country = null;
  selectedLanguage: ILanguage;
  userCards = [];
  currentUserCard;
  categories;
  refreshSubscription: Subscription;
  merchantOfferSubscription: Subscription
  userVerifiedBin: string = "";
  allCountries: any = [];
  filteredCountries = [];
  countrySearchTerm = '';
  public languageSearchTerm: string = '';
  public categorySidebarVisible: boolean = false;
  public languageSidebarVisible: boolean = false;
  public isChinaIpLocation: boolean = false;

  @HostListener('unloaded')
  ngOnDestroy() {
    // this.dataTransferService.nextMessage(null)
    if(this.refreshSubscription){
      this.refreshSubscription.unsubscribe()
    }
    if (this.merchantOfferSubscription) {
      this.merchantOfferSubscription.unsubscribe();
    }
    this.elementRef.nativeElement.remove();
  }
  constructor(
    public _authService: AuthService,
    private offerService: OfferService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    private modalService: BsModalService,
    private _apiService: ApiService,
    private dataTransferService: DataTransferService,
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private readonly store: Store,
    @Inject(LOCALE_ID) public locale: string,
    private titleService: Title
  ) {
    this.commonService.changeCard$.subscribe((res: any) => {
      if (res === 'change') {
        this.accDropCon.show();
        this.openMenu = true;
        setTimeout(() => {
          this.openMenu = false;
        }, 100);
      }
    });
  }

  ngOnInit() {
    this.checkAuth();
    this.checkCountry();
    this.checkRefresh();
    this.getIpLocation();
    this.selectedCountry();
    if (!this.merchantOfferSubscription) {
      this.merchantOfferSubscription = this.dataTransferService.sharedMerchantOfferEvent.subscribe(res => {
        window['di'] = this.createDataLayer(res);
      })
    }
  }
  checkAuth(){
    if (this._authService.isAuthenticated()) {
      // this.getCards(true);
      this.userVerifiedBin = sessionStorage.getItem("userVerifiedBin");
    }
  }
  checkRefresh(){
    if(!this.refreshSubscription){
      this.refreshSubscription = this.dataTransferService.sharedRefreshEvent.subscribe(res => {
        if(res && res.refresh){
          this.getCategoryDetails();
          this.userVerifiedBin = sessionStorage.getItem("userVerifiedBin");
          // this.getCards(true)
        }
      });
    }
  }
  getCategoryDetails() {
    this.dataTransferService.nextCategories({isLoading: true});
    var params = {
      'benefit_type': 'offers',
      'sub_category': true
    };
    this.offerService.getCategoryDetails(params).subscribe(
      (res: any) => {
        this.categories = res.data;
        this.dataTransferService.nextCategories(res);
      },
      (err) => {
      }
    );
  }
 async checkCountry(){
    let userCountry = JSON.parse(localStorage.getItem('userCountry'));
    this.dataTransferService.nextSelectedCountry(userCountry);
    await this.commonService.setCountryData();
    this.commonService.getAllCountries().subscribe((res: any) => {
      if(res && res?.ip_country && !userCountry){
        let country = {
          attributes: res.ip_country,
          id: res.ip_country.id
        }
        userCountry = country;
        this.setCountry(country, true);
        this.loadDataLayerScript();
      }
      else{
        this.loadDataLayerScript();
        if (!userCountry) {
          this.showLocationModal(false)
        }
      }
      if(res && res?.data){
        localStorage.setItem('allCountries', JSON.stringify(res.data));
        this.allCountries = res?.data;
        this.filteredCountries = res?.data;
      }
      this.getLanguages();
    }, (err) => {
      this.showLocationModal(false)
    })
  }
  selectedCountry(){
    let userCountry = JSON.parse(localStorage.getItem('userCountry'));
    if(userCountry){
      this.selectedCountryDetails = userCountry
    }
  }
  public getIpLocation(): void {
    this.isChinaIpLocation = this.commonService.isChinaIpLocation();
  }
  getCards(isReload = false) {
    this.store.pipe(select((state: any) => state.cards)).subscribe((res) => {
      if(res && res.cards && !isReload){
        // this.userCards = res.cards.data;
        this.userCards = res.cards.data.map((item) => ({
           ...item
          }));
        this.checkSelectedCard();
        isReload = false;
      }
      else{
        this.store.dispatch(cardsActions.getCards({}));
      }
      isReload = false;
    });
  }
  checkSelectedCard(){
    if (localStorage.getItem('uc') && localStorage.getItem('uc') != 'undefined') {
      let usercard = JSON.parse(localStorage.getItem('uc'));
      this.userCards.forEach((x) => {
        if (usercard && (x.id === usercard)) {
          x['currentCard'] = true;
        } else {
          x['currentCard'] = false;
        }
      });
      console.log(this.userCards);
      this.userCards.sort(function(x,y){ return x.currentCard ? -1 : y.currentCard ? 1 : 0; });
    }
    else{
      this._authService.logout()
    }
  }
  setCurrentUserCards(card) {
    this.validateCard(card.attributes.bin, card.attributes.bin_type);
  }

  validateCard(bin, bin_type) {
    this._authService.validateCard(bin, bin_type).subscribe(res => {
      if (res && res.data && res.data.attributes.bin == bin && (res.data.attributes.status == 'bin_verified' || res.data.attributes.status == 'payment_verified')) {
        let current_user = JSON.parse(localStorage.getItem("currentUser"));
        current_user.token = res.data.attributes.session_token;
        localStorage.setItem('currentUser', JSON.stringify(current_user));
        localStorage.setItem('card_verified', "true");
        localStorage.setItem('uc', JSON.stringify(res.data.id));
        location.reload();
      }
      else {
        localStorage.setItem('card_verified', "false");
      }
    })
  }

  openLoginModal() {
    this.sideMenu = false;
    const initialState = {}
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'login-modal'
    };
    this.modalRef = this.modalService.show(LoginComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.closeModal.subscribe(res => {
      this.modalRef.hide();
    });
    this.modalRef.content.loginStatus.subscribe((res) => {
      if(res) {
        this.ngOnInit();
      }
    })
  }
  openAddCardModal() {
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'add-modal'
    };
    this.modalRef = this.modalService.show(AddCardModalComponent, Object.assign({}, config, { }));
  }
  logout() {
    this._authService.logout(true);
  }

  filterItem(searchTerm){
   if(searchTerm && searchTerm.length > 0){
      this.filteredCountries = Object.assign([], this.allCountries).filter(
        item => item.attributes.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
     )
   }
   else{
     this.filteredCountries = this.allCountries;
   }
  }

  public filterLanguages(searchTerm) {
    if (searchTerm && searchTerm.length > 0) {
      this.filteredLanguages = Object.assign([], this.languages).filter(
        item => item.attributes.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      )
    }
    else {
      this.filteredLanguages = this.languages;
    }
  }


  setCountry(country, defaultCountryLang = false, reloadRequired = false) {
    localStorage.setItem("userCountry", JSON.stringify(country));
    this.dataTransferService.nextSelectedCountry(country);
    this.filteredCountries = this.allCountries;
    // if(this._document.location.pathname.includes("offers/details") || this._document.location.pathname.includes("offers/list")){
    //   window.location.href = "/";
    // }
    // else{
      // this.getCategoryDetails();
    // }
    if (country?.attributes?.languages?.length) {
      let resLanguage = country?.attributes?.languages?.find((language: any) => this.availableTranslatedLanguages?.includes(language?.iso639_1));
      if (!resLanguage) {
        resLanguage = this.languages.find((language: ILanguage) => language?.attributes?.iso639_1 === 'en')
        resLanguage = resLanguage?.attributes;
      }
      const language: ILanguage = {
        attributes: {...resLanguage},
        id: resLanguage?.id,
        type: "language"

      }
      this.setLanguage(language, defaultCountryLang, reloadRequired);
    } else {
      if (reloadRequired) {
        location?.reload();
      }
    }
  }

  showLocationModal(allowClose = true){
      const initialState = {
        allCountries: this.allCountries ? this.allCountries : null
      }
      var config = {
        backdrop: true,
        ignoreBackdropClick: allowClose ? false : true,
        keyboard : allowClose ? true : false
      };
      this.modalRef = this.modalService.show(CountryModalComponent, Object.assign({}, config, { initialState }));
      this.modalRef.content.hideEvent.subscribe(res => {
        if (res) { this.modalRef.hide(); }
      })
  }

  openSearchModal() {
    const initialState = {}
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'search-modal'
    };
    this.modalRef = this.modalService.show(SearchComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.hideEvent.subscribe(res => {
      if (res) { this.modalRef.hide(); }
    })
  }

  setLanguage(lang, defaultCountryLang = false, reloadRequired = false){
    this.selectedLanguage = { ...lang };
    this.commonService.changeLanguageEmit(this.selectedLanguage);
    if (this.locale !== this.selectedLanguage?.attributes?.iso639_1 && (!defaultCountryLang || this.locale === 'en')) {
      let additionalPath = '';
      this.availableTranslatedLanguages.forEach((language_code) => {
        if (window.location.pathname?.includes(`/${language_code}/`)) {
          additionalPath = window.location.pathname.replace(`/${language_code}`, '');
        }
      })
      window.open(`${window.location.origin}/${this.selectedLanguage?.attributes?.iso639_1}/${additionalPath}`, '_self')
    } else {
      if (reloadRequired) {
        location?.reload();
      }
    }
  }

  public analyticsLinkData(type: string) {
    const payload = {
      siteSection: 'top_navigation',
      button_name: type,
      pageURL: window.location.href,
      clickPosition: type
    }
    this.commonService.sendAnalyticsData('top_nav', 'headerInfo' , payload)
  }

  public analyticsDropdownSelectorData(type: string, value: string, title?: string , parent_code?:string ) {
    const pageRedirectData = type.includes('categories')? window.location.origin + `/offers/list/${parent_code}/${value}` : window.location.href ;
    const payload = {
        siteSection: 'top_navigation',
        button_name: title || value,
        pageURL: pageRedirectData,
        clickPosition: type
    }
    this.commonService.sendAnalyticsData('top_nav', 'headerInfo' ,payload)
  }

  public showInDropdown(languageLocale) {
    return !this.hideInDropdownLanguages.includes(languageLocale);
  }

  private getLanguages() {
    this.commonService.getLanguages().toPromise().then((res: {data: ILanguage[]}) => {
      this.languages = res?.data?.filter((language: ILanguage) => this.availableTranslatedLanguages?.includes(language?.attributes?.iso639_1));
      this.filteredLanguages = this.languages;
      if (!this.selectedLanguage || this.selectedLanguage?.attributes?.iso639_1 !== this.locale) {
        this.selectedLanguage = this.languages.find((language: ILanguage) => language?.attributes?.iso639_1 === this.locale)
        this.setLanguage(this.selectedLanguage);
      }
      this.getCategoryDetails();
      this.commonService.countryEvent.next(true);
    }).catch(err => {
      console.log('error while fetching languages', err)
      this.getCategoryDetails();
    })
  }

  private loadDataLayerScript() {
    var dataLayerScript = document.createElement("script");
    dataLayerScript.text =  `var di = ${JSON.stringify(this.createDataLayer())}`;
    document.head.appendChild(dataLayerScript);
  }

  private createDataLayer(dynamicData: any = {}) {
    const staticDataLayer = {
      siteName: `${document.location.hostname.includes('sandbox') ? 'Sandbox MasterCard' : 'MasterCard | Easysavingsspecials'}`, 
      siteSection1: "Home Page",
      siteSection2: "Offer Page",
      pageName: "Home Page", 
      contentType: "Home Page - Offer listing",
      pageURL: `${window.location.href}`,
      pageTitle: `${this.titleService.getTitle()}`,
      region:  `${this.selectedCountryDetails?.attributes?.region}`, 
      country: `${this.selectedCountryDetails?.attributes?.iso2_code}`,
      language: `${this.locale}`,
      pageType: "B2B2C",
      loginType: `${this._authService.isAuthenticated() ? 'Logged-In' : 'Guest'}`,
    };
    return {...staticDataLayer, ...dynamicData}
  }

  public handleCategorySelection(category: Category): void {
    this.sideMenu=false;
    this.categorySidebarVisible=false;
    this.analyticsDropdownSelectorData('categories', category?.attributes?.code, category?.attributes?.name)
  }
}